import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type DrawerContentProps = BoxProps;

export const DrawerContent: React.ComponentType<DrawerContentProps> = styled(
  Box,
)<DrawerContentProps>(() => ({
  flex: 1,
  overflowY: 'auto',
  marginRight: '-24px',
  paddingRight: '24px',
}));
